import React from "react";

import svg from "../../assets/images/icons/RichText/italic.svg";

export const ItalicIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Italic"}
    />
);
